import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter, faInstagram, faTiktok, faYoutube, faTwitch, faApplePay, faCcAmex, faCcMastercard, faCcPaypal, faCcVisa} from "@fortawesome/free-brands-svg-icons";
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  const today = new Date();
  const [openSections, setOpenSections] = useState({
    informations: false,
    socials: false,
    shop: false
  });

  const handleToggle = (section) => {
    // Ne déclencher le toggle que si la largeur d'écran est inférieure à 1024px
    if (window.innerWidth < 1024) {
      setOpenSections(prev => ({
        ...prev,
        [section]: !prev[section]
      }));
    }
  };

  return (
    <footer>
      <div className="footer-container">
        <div className={`informations ${openSections.informations ? 'open' : ''}`}>
          <h3 onClick={() => handleToggle('informations')}>
            Informations
            <FontAwesomeIcon className="chevron" icon={openSections.informations ? faChevronUp : faChevronDown} />
          </h3>
          <div>
            <ul>
              <li><a href="">FAQ</a></li>
              <li><a href="">Contact</a></li>
              <li><a href="">Mentions légales</a></li>
              <li><a href="">Conditions générales de vente</a></li>
              <li><a href="">Politique de confidentialité</a></li>
            </ul>
          </div>
        </div>

        <div className={`socials ${openSections.socials ? 'open' : ''}`}>
          <h3 onClick={() => handleToggle('socials')}>
            Nos réseaux
            <FontAwesomeIcon className="chevron" icon={openSections.socials ? faChevronUp : faChevronDown} />
          </h3>
          <div>
            <ul>
              <li>
                <FontAwesomeIcon icon={faXTwitter} />
                <a href="https://x.com/BMS_CREW" target="blank">Twitter</a>
              </li>
              <li>
                <FontAwesomeIcon icon={faInstagram} />
                <a href="https://www.instagram.com/thebmsesports/" target="blank">Instagram</a>
              </li>
              <li>
                <FontAwesomeIcon icon={faTiktok} />
                <a href="https://www.tiktok.com/@bmsjoel" target="blank">TikTok</a>
              </li>
              <li>
                <FontAwesomeIcon icon={faYoutube} />
                <a href="https://www.youtube.com/@BMSESPORTS" target="blank">Youtube</a>
              </li>
              <li>
                <FontAwesomeIcon icon={faTwitch} />
                <a href="https://www.twitch.tv/bmsjoel" target="blank">Twitch</a>
              </li>
            </ul>
          </div>
        </div>

        <div className={`footer-shop ${openSections.shop ? 'open' : ''}`}>
          <h3 onClick={() => handleToggle('shop')}>
            Notre boutique
            <FontAwesomeIcon className="chevron" icon={openSections.shop ? faChevronUp : faChevronDown} />
          </h3>
          <div>
            <ul>
              <li><a href="https://thebmscrew.com/collections" target="_blank">Nos produits</a></li>
              <li><a href="https://thebmscrew.com/collections/acessoires" target="_blank">Accessoires</a></li>
              <li><a href="https://thebmscrew.com/collections/drip" target="_blank">Drip</a></li>
              <li><a href="https://thebmscrew.com/collections/esports" target="_blank">Esports</a></li>
              <li><a href="https://thebmscrew.com/collections/manettes" target="_blank">Hardware</a></li>
              <li><a href="https://thebmscrew.com/collections/sports" target="_blank">Sports</a></li>
              <li><a href="https://thebmscrew.com/collections/supporters" target="_blank">Supporters</a></li>
            </ul>
          </div>
        </div>

        <div className="payment-method">
          <h3>Moyens de paiements</h3>
          <div>
            <ul>
              <li><FontAwesomeIcon icon={faApplePay} /></li>
              <li><FontAwesomeIcon icon={faCcAmex} /></li>
              <li><FontAwesomeIcon icon={faCcPaypal} /></li>
              <li><FontAwesomeIcon icon={faCcMastercard} /></li>
              <li><FontAwesomeIcon icon={faCcVisa} /></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="credit-container">
        <p>Copyright &copy; {today.getFullYear()} BMS The Black Mafia&#8482; Maaxy</p>
      </div>
    </footer>
  );
}

export default Footer;